import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from "../commons/abstract.service";

@Injectable({ providedIn: 'root' })
export class LossReasonService extends AbstractService<any> {
  constructor(private http: HttpClient) {
    super(http);
  }

  getURLBase(): string {
    return '/loss-reason';
  }

  preCreate(obj: any): void {
    delete obj._id;
  }

  preUpdate(obj: any): void {
  }
}
